<template>
  <div class="gantt__row">
    <div class="gantt__row-first">
      <div class="tarifa-row-info">
        <div class="tarifa-row-header">
          <h4 class="tarifa-row-name">
            {{(tarifa.SubcategoriaData && tarifa.SubcategoriaData.length)
              ? tarifa.SubcategoriaData.map(s => s.text).join(', ')
              : 'Sin subcategoría'}}
          </h4>

        </div>

        <div class="tarifa-row-subcategorias">
          <v-chip x-small outlined color="#64748b" class="tarifa-sub-chip">
            <i class="lni lni-calendar mr-1" style="font-size: 10px;"></i>
            {{ tarifa.temporadaNombre }}
          </v-chip>
        </div>
        <v-chip x-small :color="mercadoColor(tarifa.Mercado)" dark class="tarifa-row-badge">
          {{ nombreMercado }}
        </v-chip>
        <v-divider></v-divider>
        <!-- Botones de acción con hover -->
        <v-fade-transition>
          <div class="tarifa-row-actions">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" x-small depressed color="#2563eb" dark @click="editTemporada(tarifa.id)"
                  class="action-btn">
                  <i class="lni lni-pencil-alt" style="font-size: 10px;"></i>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" x-small depressed color="#d97706" dark @click="replyTarifa(tarifa.id)"
                  class="action-btn">
                  <i class="lni lni-files" style="font-size: 10px;"></i>
                </v-btn>
              </template>
              <span>Replicar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" x-small depressed color="#dc2626" dark
                  @click="deleteTarifaTable(tarifa.id)" class="action-btn">
                  <i class="lni lni-trash" style="font-size: 10px;"></i>
                </v-btn>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </div>
        </v-fade-transition>
      </div>
    </div>

    <ul class="gantt__row-bars">
      <template v-for="modalidades in tarifa.arrayPrecios">
        <template v-for="(horarios, index) in modalidades.horarios">
          <li class="tarifa-bar" v-bind:style="{
            'grid-column': horarios.indexStart + '/' + horarios.indexEnd,
            'background-color': horarios.color,
          }" :key="index + '_' + tarifa.id + modalidades.id + modalidades.dias"
            @click="showInfo(modalidades, horarios)">
            <div class="bar-header">
              <span class="bar-time">{{ horarios.data.HoraInicio }} - {{ horarios.data.HoraTermino }}</span>
              <span class="bar-modalidad">{{ modalidades.Nombre }}</span>
            </div>
            <div class="bar-price">${{ horarios.PcoVen }} {{ horarios.Moneda }}</div>
          </li>
        </template>
      </template>
    </ul>
  </div>
</template>

<style scoped>
.tarifa-row-info {
  padding: 0.65rem 0.75rem;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  height: 100%;
  justify-content: center;
}

.tarifa-row-header {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.tarifa-row-name {
  margin: 0;
  font-size: 0.93rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
}

.tarifa-row-badge {
  font-size: 0.6rem !important;
  font-weight: 700 !important;
  height: 18px !important;
  letter-spacing: 0.2px;
}

.tarifa-row-subcategorias {
  display: flex;
  gap: 0.2rem;
  flex-wrap: wrap;
}

.tarifa-sub-chip {
  font-size: 0.6rem !important;
  height: 18px !important;
  border-width: 1px !important;
}

.tarifa-row-actions {
  display: flex;
  gap: 0.3rem;
  flex-wrap: wrap;
  margin-top: 0.15rem;
}

.action-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  font-size: 0.65rem !important;
  border-radius: 4px !important;
  height: 22px !important;
}

/* Barras */
.tarifa-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4px 8px !important;
  gap: 2px;
  font-size: 11px !important;
  border-radius: 6px !important;
}

.bar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.bar-time {
  font-size: 0.65rem;
  font-weight: 700;
  opacity: 0.95;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bar-price {
  font-size: 0.75rem;
  font-weight: 800;
  line-height: 1.1;
  white-space: nowrap;
}

.bar-modalidad {
  font-size: 0.6rem;
  font-weight: 500;
  opacity: 0.85;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "tarifaRow",
  components: {},
  props: ["tarifa", "bus"],
  data() {
    return {
      MainDepartamento: "",
      isHovered: false,
    };
  },
  methods: {
    ...mapActions("TarifasStore", ["getMercadosReserva"]),
    showActions(tarifa) {
      this.$swal({
        title: "<strong><u>Tarifa " + tarifa.Horario.Nombre + "</u></strong>",

        html:
          "De " +
          tarifa.Horario.HoraInicio +
          " a " +
          tarifa.Horario.HoraTermino +
          " </br>" +
          "Precio:" +
          tarifa.Precio +
          "USD</br>" +
          "</br>",
        showCloseButton: true,
        showCancelButton: false,
        focusConfirm: false,
        showConfirmButton: false,
      });
    },
    showInfo(modalidad, horario) {
      this.$toast.show(
        "Horario " +
        horario.Nombre +
        "<br/>" +
        "De " +
        horario.data.HoraInicio +
        " a " +
        horario.data.HoraTermino +
        " </br>" +
        " " +
        modalidad.Nombre +
        "<br/>" +
        " " +
        modalidad.textDias +
        "<br/>" +
        "Precio:" +
        horario.PcoVen +
        " " +
        horario.Moneda +
        "</br>" +
        "</br>",
        "Detalle de Horario",
        {
          position: "center",
          theme: "dark",
          layout: 2,
          progressBar: false,
          overlay: true,
          close: false,
          timeout: false,
          displayMode: 2,
          progressBarColor: "rgb(0, 255, 184)",
          buttons: [
            [
              "<button>Cerrar</button>",
              function (instance, toast) {
                instance.hide(
                  {
                    transitionOut: "fadeOutUp",
                    onClosing: function (instance, toast, closedBy) {
                      //     console.info("closedBy: " + closedBy); // The return will be: 'closedBy: buttonName'
                    },
                  },
                  toast,
                  "buttonName"
                );
              },
            ],
          ],
        }
      );
    },
    deleteTarifa(id, idTipoJuego, Temporada, idTarifa) {
      let data = {
        idHorario: id,
        idTarifa: idTarifa,
        idTemporada: Temporada.id,
        idTipoJuego: idTipoJuego,
      };

      this.$pgsHelper.log(data);
      data.Departamento = this.MainDepartamento;
      const deletedObject = { ...data, temporada: Temporada, tarifa: this.tarifa };
      this.$swal({
        title: "¿Deseas eliminar este Horario?",
        text: "El horario no sera accesible nuevamente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          //var addTarifa = this.$store.getters.getFirebaseApp.fba.call('Golf-Tarifas-eliminarPrecioTarifa');
          return await this.$store.getters.getFirebaseApp.fba
            .call("Golf-Tarifas-eliminarPrecioTarifa", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "TARIFA_HORARIO_DELETE",
              Mensaje: `Horario de tarifa eliminado: ${this.tarifa?.Nombre || id}`,
              reference: { id: id, tp: "Golf-TarifaHorario", al: this.tarifa?.Nombre || "HORARIO" },
              data: deletedObject
            });
            this.$swal(
              "Horario Eliminado",
              "El horario se elimino correctamente",
              "success"
            );

            this.bus.$emit("refreshList");
          } else {
            this.$swal("Error saving data", "Your data didnt save", "error");
          }
        }
      });
    },
    editTemporada(idTarifa) {
      this.bus.$emit("editTarifa", idTarifa);
    },
    replyTarifa(idTarifa) {
      this.bus.$emit("replyTarifa", idTarifa);
    },
    deleteTarifaTable(idTarifa) {
      let data = {
        Id: idTarifa,
      };

      data.Departamento = this.MainDepartamento;
      const deletedObject = this.tarifa || data;

      this.$swal({
        title: "¿Deseas eliminar esta tarifa?",
        text: "Se eliminaran los horarios que esten dentro de esta temporda",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          //var addTarifa = this.$store.getters.getFirebaseApp.fba.call('Golf-Tarifas-eliminarTemporadaTarifa');
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Tarifas-deleteTarifa", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "TARIFA_DELETE",
              Mensaje: `Tarifa eliminada: ${this.tarifa?.Nombre || idTarifa}`,
              reference: { id: idTarifa, tp: "RVA-Tarifa", al: this.tarifa?.Nombre || "TARIFA" },
              data: deletedObject
            });
            this.$swal(
              "Tarifa Eliminada",
              "La tarifa se elimino correctamente",
              "success"
            );

            this.$emit("successDelete", true);
          } else {
            this.$swal("Error saving data", result.value.data.error, "error");
          }
        }
      });
    },
    mercadoColor(mercadoId) {
      if (!mercadoId) return "#64748b";

      const colors = [
        "#2563eb", // Azul
        "#059669", // Verde
        "#7c3aed", // Púrpura
        "#d97706", // Ámbar
        "#dc2626", // Rojo
        "#0891b2", // Cian
        "#4f46e5", // Índigo
        "#db2777", // Rosa
      ];

      if (this.mercadosReserva && this.mercadosReserva.length > 0) {
        const idx = this.mercadosReserva.findIndex((m) => m.id === mercadoId);
        if (idx !== -1) {
          return colors[idx % colors.length];
        }
      }

      let hash = 0;
      for (let i = 0; i < mercadoId.length; i++) {
        hash = mercadoId.charCodeAt(i) + ((hash << 5) - hash);
      }
      return colors[Math.abs(hash) % colors.length];
    },
  },
  computed: {
    ...mapGetters("TarifasStore", {
      mercadosReserva: "getMercadosReserva",
    }),
    nombreMercado() {
      if (this.tarifa && this.tarifa.Mercado) {
        if (this.mercadosReserva && this.mercadosReserva.length > 0) {
          const mercado = this.mercadosReserva.find((m) => m.id === this.tarifa.Mercado);
          if (mercado) return mercado.nm || mercado.nombre;
        }
        return this.tarifa.Mercado;
      }
      return this.tarifa?.Turista !== undefined
        ? (this.tarifa.Turista ? "Turista" : "Local")
        : "Sin mercado";
    },
  },
  watch: {},
  mounted() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");

    if (!this.mercadosReserva || !this.mercadosReserva.length) {
      this.getMercadosReserva();
    }

    // Hover detection via native events since the row is a custom layout
    this.$el.addEventListener("mouseenter", () => { this.isHovered = true; });
    this.$el.addEventListener("mouseleave", () => { this.isHovered = false; });
  },
};
</script>
